export const FRAME_ID = 'apple-pay';
